//方便测试，全局定义测试变量 true测试模式， false为正常模式
let testMode = false
// let testMode = true
export function isTestMode() {
    return testMode
}


// WEBPACK FOOTER //
// ./src/common/testConfig.js